import { canAccessAgentChatSelector } from '@lumapps/agent-chat-global/ducks/selectors';
import { isFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { isInstanceSuperAdmin, isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { CONTENT_ANALYTICS_AUDITOR_AGENT_FF } from '../constants';

/** Check whether the current user has access to the all content page in the back-office
 * To has access those conditions should be met:
 * - User is global or site admin
 */
const isContentBulkAllowed = createSelector(
    isSuperAdmin,
    isInstanceSuperAdmin,
    (isGlobalAdmin, isSiteAdmin) => isGlobalAdmin || isSiteAdmin,
);

const isContentBulkCalendarViewFeaturedEnabled = isFeatureEnabled('content-bulk-calendar-view');
/** Content Analytics Auditor agent: gated by global agent chat access and its dedicated flag. */
export const isContentAnalyticsAuditorAgentEnabled = createSelector(
    canAccessAgentChatSelector,
    isFeatureEnabled(CONTENT_ANALYTICS_AUDITOR_AGENT_FF),
    (canAccessAgentChat, isAuditorFlagEnabled) => canAccessAgentChat && isAuditorFlagEnabled,
);
const isContentBulkCalendarViewAllowed = createSelector(
    isContentBulkAllowed,
    isContentBulkCalendarViewFeaturedEnabled,
    (contentBulkAllowed, contentBulkCalendarViewAllowed) => contentBulkAllowed && !!contentBulkCalendarViewAllowed,
);

export { isContentBulkAllowed, isContentBulkCalendarViewAllowed };
